export const getPosterizeArgs = (p) => {
    return {
        color: {
            posterize_light: p.color.posterize_light[p.color.posterize_light_color],
            posterize_light_color: p.color.posterize_light_color,
            posterize_shadow: p.color.posterize_shadow[p.color.posterize_shadow_color],
            posterize_shadow_color: p.color.posterize_shadow_color,
        },
    };
};
